import React from "react";
import { useGetList } from "react-admin";

// Outgoing document (SI) statuses from the backend canonical dictionary, so the
// wording and colors stay consistent across the app (orders list popup, order
// groups page, etc.).
export const useOutDocStatuses = () => {
	const { data: statusesById } = useGetList(
		"outgoing-doc-statuses",
		{ page: 0, perPage: -1 },
		{ field: "id", order: "ASC" },
		{}
	);

	const choices = React.useMemo(
		() =>
			Object.values(statusesById || {}).map((status) => ({
				id: status.id,
				name: status.name,
			})),
		[statusesById]
	);

	return { statusesById, choices };
};
